import { CSSObject } from '@chakra-ui/react';
import {
  TButtonProp,
  TFlexPropWrapper,
  TTextProp,
} from './Propositions.styles';

export const FlexPropWrapper = ({
  propLength,
}: TFlexPropWrapper): CSSObject => ({
  ...(!!propLength && {}),
});

export const ButtonProp = ({
  propLength,
  isSelected,
}: TButtonProp): CSSObject => ({
  '&&': {
    borderRadius: '7px',
    bg: 'transparent',
    boxShadow: 'none',
    border: 'none',

    '&:disabled': { bg: 'transparent' },

    ...((propLength ?? 0) === 2 && {
      p: 0,
    }),
    ...((propLength ?? 0) > 2 && {
      borderTop: '1px dashed',
      borderTopColor: 'gray.200',
      p: '2',

      _first: { borderTop: 0 },
    }),
    ...(!!isSelected && {}),
  },
});

export const TextProp = ({ propLength, isSelected }: TTextProp): CSSObject => ({
  '&&': {
    fontSize: 'sm',

    _first: {
      color: 'gray.700',
      fontWeight: 'bold',

      'button:hover &': { color: 'gray.700' },

      ...((propLength ?? 0) === 2 && {
        mb: '1',
      }),
      ...((propLength ?? 0) > 2 && {
        fontSize: 'sm',
        fontWeight: 'semibold',
      }),
    },

    '&.return-amount': {
      bgGradient: isSelected
        ? 'linear(to-b, delta.600, delta.600)'
        : 'linear(to-b, alpha.400, alpha.600)',
      p: 2,
      w: 'full',
      borderRadius: 'base',
      color: 'white',
      fontWeight: 'black',
      textShadow: isSelected
        ? '0px 1px 3px rgba(0, 0, 0, 0.40)'
        : '0px 1px 2px rgba(0, 0, 0, 0.60)',
      boxShadow: isSelected
        ? '0px 0px 0px 2px #FDD101 inset, 0px 0px 0px 4px #26830B inset, 0px 0px 0px 5px #89D255 inset'
        : '0px 0px 0px 2px #FDD101 inset, 0px 0px 0px 4px #26830B inset, 0px 0px 0px 5px #89D255 inset, 0px 3px 7px 0px rgba(0, 0, 0, 0.45)',

      transition: 'all, .3s ease-in-out',

      _hover: {
        bgGradient: 'linear(to-b, alpha.600, alpha.600)',
      },

      ...((propLength ?? 0) > 2 && {
        maxW: '48px',
      }),
    },

    ...(!!isSelected && {}),
  },
});
